import { Button, Header, Segment } from 'semantic-ui-react';

import {
    GEN1_APPLICATION_TYPE_LABEL_NEW_PURCHASE_ONLY,
    GEN1_APPLICATION_TYPE_LABEL_PURCHASED_ONLY,
    getGen1ApplicationTypeLabel,
} from '../gen1ApplicationType';

/**
 * Trunking Order 申請種別選択（UC-02）。
 * @param {{
 *   mode?: 'default' | 'change',
 *   currentIncludePurchasedRepeaters?: boolean,
 *   onSelect: (includePurchasedRepeaters: boolean) => void,
 *   onCancel?: () => void,
 *   disabled?: boolean,
 * }} props
 */
export default function Gen1ApplicationTypeSelect({
    mode = 'default',
    currentIncludePurchasedRepeaters,
    onSelect,
    onCancel,
    disabled = false,
}) {
    const isChangeMode = mode === 'change';
    const currentLabel = getGen1ApplicationTypeLabel(
        currentIncludePurchasedRepeaters
    );

    return (
        <>
            <Header
                as="h2"
                icon="list"
                content={
                    isChangeMode
                        ? 'Gen1 Trunking Order — Change Application Type'
                        : 'Gen1 Trunking Order — Select Application Type'
                }
                style={{ marginBottom: '0.5rem' }}
            />
            {isChangeMode ? (
                <p style={{ marginBottom: '1.25rem', color: '#555' }}>
                    Current application type: <strong>{currentLabel}</strong>.
                    Select a different type and choose Continue to change. While
                    the order is Draft, you may change the application type;
                    after submission (Ordered) it cannot be changed. Trunking
                    Information will be reset when you switch to a different
                    type; Customer Information will be kept.
                </p>
            ) : (
                <p style={{ marginBottom: '1.25rem', color: '#555' }}>
                    Choose the type of repeater application. This selection
                    applies to the entire order. While the order is Draft, you
                    may change the application type later; after submission
                    (Ordered) it cannot be changed.
                </p>
            )}
            <Segment.Group horizontal style={{ maxWidth: 720 }}>
                <Segment
                    placeholder
                    style={{ flex: 1, textAlign: 'center', padding: '1.5rem' }}
                >
                    <Header
                        as="h3"
                        content={GEN1_APPLICATION_TYPE_LABEL_NEW_PURCHASE_ONLY}
                    />
                    <p style={{ minHeight: 48, color: '#666' }}>
                        Order new repeaters only. SO# Search and serial numbers
                        for purchased units are not used on this application
                        type.
                    </p>
                    <Button
                        primary
                        content="Continue"
                        aria-label={`Select ${GEN1_APPLICATION_TYPE_LABEL_NEW_PURCHASE_ONLY}`}
                        disabled={disabled}
                        onClick={() => onSelect(false)}
                    />
                </Segment>
                <Segment
                    placeholder
                    style={{ flex: 1, textAlign: 'center', padding: '1.5rem' }}
                >
                    <Header
                        as="h3"
                        content={GEN1_APPLICATION_TYPE_LABEL_PURCHASED_ONLY}
                    />
                    <p style={{ minHeight: 48, color: '#666' }}>
                        Apply for repeaters already purchased (SO# Search, add /
                        exchange / remove operations).
                    </p>
                    <Button
                        primary
                        content="Continue"
                        aria-label={`Select ${GEN1_APPLICATION_TYPE_LABEL_PURCHASED_ONLY}`}
                        disabled={disabled}
                        onClick={() => onSelect(true)}
                    />
                </Segment>
            </Segment.Group>
            {isChangeMode && onCancel ? (
                <div style={{ marginTop: '1.25rem' }}>
                    <Button
                        type="button"
                        content="Cancel"
                        icon="arrow left"
                        labelPosition="left"
                        onClick={onCancel}
                    />
                </div>
            ) : null}
        </>
    );
}
